import React, {useMemo, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import useQueryBadges from '../../../hooks/api/badge/useQueryBadges'
import WizButton from '../../../components/button/WizButton'
import WizSelectButton from '../../../components/button/WizSelectButton'
import useNavigation from '../../../hooks/useNavigation'
import TableLayout from '../../../components/table/TableLayout'
import TableItem from '../../../components/table/TableItem'
import TableHeader from '../../../components/table/TableHeader'
import Text from '../../../components/text/Text'
import WizImage from '../../../components/image/WizImage'
import {BADGE_CATEGORIES} from '../../../apis/badge/getBadge'

interface IProps {
    className?: string
}

const ALL_CATEGORY = ''
const categoryFilterOptions = [{id: ALL_CATEGORY, value: 'All'}, ...BADGE_CATEGORIES.map(c => ({id: c, value: c}))]

const BadgePage: React.FC<IProps> = ({className}) => {
    const {goBadgeCreate, goBadgeDetail} = useNavigation()
    const [categoryFilter, setCategoryFilter] = useState(ALL_CATEGORY)
    const {data} = useQueryBadges(categoryFilter || undefined)

    const badgeList = useMemo(() => {
        return data?.data?.sort((a, b) => b.sort_order - a.sort_order)
    }, [data])

    const lang = localStorage?.getItem('lang') === 'ko' ? 'ko' : 'en'

    return (
        <PageLayout title={'Badge Management'}>
            <div className={'flex items-center gap-[15px] flex-wrap'}>
                <WizButton text={'Create Badge'} type={'primary'} className={'sm:block'} onClick={goBadgeCreate} />
                <WizSelectButton
                    data={categoryFilterOptions}
                    onChange={e => setCategoryFilter(e.id)}
                    activeValue={categoryFilterOptions.find(o => o.id === categoryFilter)}
                />
            </div>

            <div className={'mt-[30px]'}>
                <TableHeader className={'grid-cols-8 gap-x-[10px] md:hidden'}>
                    <Text>Image</Text>
                    <Text>Code</Text>
                    <Text>Name</Text>
                    <Text>Category</Text>
                    <Text>Type</Text>
                    <Text>Grant Type</Text>
                    <Text className={'text-center'}>Order</Text>
                    <Text className={'text-center'}>Status</Text>
                </TableHeader>
                <TableLayout>
                    {badgeList?.map(badge => {
                        return (
                            <TableItem
                                onClick={() => goBadgeDetail(badge?.id)}
                                key={badge?.id}
                                className={
                                    'grid-cols-8 gap-x-[10px] md:block md:space-y-[10px] sm:px-[15px] items-center'
                                }>
                                <div className={'flex items-center'}>
                                    {badge?.image_mini ? (
                                        <WizImage
                                            src={`${badge.image_mini}?type=webp&width=200&quality=80`}
                                            className={'w-[40px] h-[40px] rounded-full object-cover'}
                                        />
                                    ) : (
                                        <div
                                            className={
                                                'w-[40px] h-[40px] rounded-full bg-line02 flex items-center justify-center'
                                            }>
                                            <Text className={'text-body3 text-font03'}>N/A</Text>
                                        </div>
                                    )}
                                </div>
                                <div className={'min-w-0'}>
                                    <Text className={'text-body3 text-font03 md:hidden'}>Code</Text>
                                    <Text className={'text-ti2 break-all'}>{badge?.code}</Text>
                                </div>
                                <div>
                                    <Text className={'text-body3 text-font03 md:hidden'}>Name</Text>
                                    <Text className={'text-ti2'}>{badge?.name_i18n?.[lang] || badge?.code}</Text>
                                </div>
                                <div>
                                    <Text className={'text-body3 text-font03 md:hidden'}>Category</Text>
                                    <Text className={'text-ti2'}>{badge?.category}</Text>
                                </div>
                                <div>
                                    <Text className={'text-body3 text-font03 md:hidden'}>Type</Text>
                                    <Text className={'text-ti2'}>{badge?.type}</Text>
                                </div>
                                <div>
                                    <Text className={'text-body3 text-font03 md:hidden'}>Grant</Text>
                                    <Text className={'text-ti2'}>{badge?.grant_type}</Text>
                                </div>
                                <div className={'text-center'}>
                                    <Text className={'text-body3 text-font03 md:hidden'}>Order</Text>
                                    <Text className={'text-ti2'}>{badge?.sort_order}</Text>
                                </div>
                                <div className={'text-center'}>
                                    <span
                                        className={`inline-block px-[10px] py-[3px] rounded-[5px] text-body3 ${
                                            badge?.is_active
                                                ? 'bg-green-100 text-green-700'
                                                : 'bg-red-100 text-red-700'
                                        }`}>
                                        {badge?.is_active ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                            </TableItem>
                        )
                    })}
                </TableLayout>
            </div>
        </PageLayout>
    )
}

export default BadgePage
